export function normalizeInsuranceCollection(patientResponsibility, patientCollected, patientRemaining) {
  const responsibility = Math.max(0, Number(patientResponsibility) || 0);
  const collected = Math.min(
    responsibility,
    Math.max(0, Number(patientCollected) || 0),
  );
  const hasReportedRemaining = patientRemaining !== undefined
    && patientRemaining !== null
    && Number.isFinite(Number(patientRemaining));
  const remaining = hasReportedRemaining
    ? Math.min(responsibility, Math.max(0, Number(patientRemaining)))
    : Math.max(0, responsibility - collected);

  return { collected, remaining };
}
